import styled from '@emotion/styled';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';

export const MuiContentEditable = styled(ContentEditable)({
  minHeight: 'fit-content',
  width: '100%',
  borderRadius: 5,
  position: 'relative',
  outline: 'none',
  padding: '0.3rem 0',
  overflow: 'none'
});